import {
  BarcodeScannerActionTypes,
  BarcodeScannerState,
  SET_SCANNED_CODE,
} from './types';

const initialState: BarcodeScannerState = {
  scannedCode: undefined,
};

export function barcodeScannerReducer(
  state = initialState,
  action: BarcodeScannerActionTypes
): BarcodeScannerState {
  switch (action.type) {
    case SET_SCANNED_CODE: {
      return {
        ...state,
        scannedCode: action.payload.scannedCode,
      };
    }

    default:
      return state;
  }
}
